const ORGANIZATION_ID = import.meta.env.VITE_ORGANIZATION_ID as
  | string
  | undefined;

export function useOrganizationId(): string | null {
  return ORGANIZATION_ID ?? null;
}
